export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Free Inspection',
      description: 'We conduct a thorough assessment of your property to identify moisture issues and determine the best waterproofing solution for your needs.',
      icon: 'ri-search-eye-line'
    },
    {
      number: '02',
      title: 'Custom Design',
      description: 'Our experts create a tailored waterproofing plan specific to your property, using proven methods and quality materials.',
      icon: 'ri-draft-line'
    },
    {
      number: '03',
      title: 'Professional Installation',
      description: 'Licensed technicians execute the plan with precision, ensuring every detail meets our high standards for quality and durability.',
      icon: 'ri-tools-fill'
    },
    {
      number: '04',
      title: 'Quality Follow-Up',
      description: 'We stand behind our work with comprehensive warranties and ongoing support to ensure your complete satisfaction.',
      icon: 'ri-shield-check-fill'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-teal-600">Proven Process</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            A streamlined approach to delivering exceptional waterproofing results
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-teal-400 to-teal-200 -z-10"></div>
              )}

              {/* Step Card */}
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 h-full">
                {/* Icon */}
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-12 h-12 bg-slate-900 rounded-lg flex items-center justify-center shadow-md">
                    <span className="text-lg font-bold text-white">{step.number}</span>
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#contact"
            className="inline-flex items-center bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Start Your Project Today
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
